import type { CSSProperties } from 'react';
import OrganizationIconSvg from '../../assets/icons/organization.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const OrganizationIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <OrganizationIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default OrganizationIcon;
